<template>
    <div>
        <div class="columns">
            <div class="column is-6">
                <img src="../../assets/sss2019.png"/>
            </div>
            <div class="column is-6">
                <img src="../../assets/traintaxbir.jpg"/>
                <img src="../../assets/philhealthtable2019to2025.jpg"/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
